import { load, saveConfirmed } from "./storage.js";
import { SYSTEM_ARCHITECTURE } from "./systemArchitecture.mjs";
import { validateRecord } from "./recordValidation.mjs";

export function createRepository({ loadFn, saveFn }) {
  return {
    async getStore(key) { return (await loadFn(key)) ?? []; },
    async setStore(key, value) { await saveFn(key, value); return value; },
    async getRecords(recordType) { return this.getStore(SYSTEM_ARCHITECTURE.recordTypes[recordType].store); },
    async setRecords(recordType, records, options = {}) {
      const normalized = records.map(record => validateRecord(recordType, record, options));
      await this.setStore(SYSTEM_ARCHITECTURE.recordTypes[recordType].store, normalized);
      return normalized;
    },
  };
}

export function createBrowserRepository() { return createRepository({ loadFn: load, saveFn: saveConfirmed }); }
